import React, {useEffect, useRef} from 'react';
import {ReactComponent as Gen7TreetFarSvg} from '../img/pedigree-7gen-far.svg';
import {ReactComponent as Gen7TreetMorSvg} from '../img/pedigree-7gen-mor.svg';
import {ReactComponent as DefaultFarSVG} from '../img/pedigree-far.svg';
import {ReactComponent as DefaultMorSVG} from '../img/pedigree-mor.svg';
import TabLabel from "./TabLabel";
import Fiktiv from "./Fiktiv";
import qs from "query-string";
import {useHistory, withRouter} from "react-router-dom";
import {formatDate} from "../helpers/util";


const StamtavleSVG = ({property, stamtavleData, hundNavn, far}) => {

    const svgRef = useRef(null);

    const __updateElement = (id, txt, attrs) => {
        const element = svgRef.current.querySelector('#' + id);
        __updateElementText(element, txt);
        attrs && __updateElementAttributes(element, attrs);
    }


    const __appendHundNavnLink = (id, text, url) => {
        const element = svgRef.current.querySelector('#' + id);
        if (element) {
            const elementsByTagName = element.getElementsByTagName("tspan");
            if (elementsByTagName && elementsByTagName.length > 0) {

                if (text !== null) {
                    let addChild = false;

                    if (property !== '7gen') {
                        elementsByTagName[0].removeChild(elementsByTagName[0].childNodes[0]);
                        addChild = true;
                    } else if ((elementsByTagName[0].childNodes !== null
                        && elementsByTagName[0].childNodes !== undefined
                        && elementsByTagName[0].childNodes.length === 0)
                        || (elementsByTagName[0].children !== null
                            && elementsByTagName[0].children !== undefined
                            && elementsByTagName[0].children.length === 0 )) {
                        addChild = true;
                    }
                    else {
                        elementsByTagName[0].textContent = text;
                    }

                    if (addChild) {
                        const href = document.createElementNS("http://www.w3.org/2000/svg", "a");
                        href.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", url);
                        href.appendChild(document.createTextNode(text));
                        elementsByTagName[0].appendChild(href);
                    }

                    // text;
                }
                else {
                    elementsByTagName[0].textContent = null;
                }
                //__appendTitle(element, text); Hvorfor denne?
            } else {
                console.error('could not locate tspan within element  :' + element + " and text:" + text);
            }
        } else {
            console.error('could not updateElementText for element with ID :' + element + " and text:" + text);
        }
    }

    const clipText = (text) => {
        if (text !== null) {
            return  text.length > 250 ? text.substring(0, 250) + ' ...' : text;
        }
        return null;
    }

    const __updateElementText = (element, text) => {
        if (element) {
            const elementsByTagName = element.getElementsByTagName("tspan");
            if (elementsByTagName && elementsByTagName.length > 0) {
                if (text !== null) {
                    elementsByTagName[0].textContent = text.length > 250 ? text.substring(0, 250) + ' ...' : text;
                }
                else {
                    elementsByTagName[0].textContent = null;
                }
                //__appendTitle(element, text); Hvorfor denne?
            } else {
                console.error('could not locate tspan within element  :' + element + " and text:" + text);
            }
        } else {
            console.error('could not updateElementText for element with ID :' + element + " and text:" + text);
        }
    }

    const __updateElementAttributes = (element, attrs) => {
        if (element && attrs) {
            Object.keys(attrs).forEach((key) => {
                element.setAttribute(key, attrs[key]);
            })
        }
    }

    /*
    const __updateGeneralProperties = (properties) => {
        const keys = Object.keys(properties);
        if (keys) {
            keys.forEach((key) => {
                __updateElement(key, properties[key].textContent, properties[key].attributes);
            });
        }
    }

    const __appendTitle = (textEl, txt) => {
        let title = document.createElementNS("http://www.w3.org/2000/svg", "title");
        title.textContent = txt;
        textEl.appendChild(title);
    }
    */

    useEffect(() => {
        if (far) {
            if (property !== '7gen')
                __updateElement('headline', "Indavlskoefficient (3 gen.) " + stamtavleData.innavlKoeffisientProsent + "%");
            else __updateElement('headline', "Indavlskoefficient " + stamtavleData.innavlKoeffisientProsent + "%");
        }


        if (property !== '7gen' && !far)
            __updateElement('timestamp', formatDate(stamtavleData.dato));


        if (property === '7gen' && !far) {
            __updateElement('selected-dog-name', hundNavn);
        }
                //__updateGeneralProperties(stamtavleData.properties);

        const hunder =  far ? stamtavleData.hunderFarSide : stamtavleData.hunderMorSide;


        //alle felter maa settes til blank
        var matches = svgRef.current.querySelectorAll("[id^='name-']");
        for (let i = 0; i < matches.length; i++) {
            __appendHundNavnLink(matches[i].id, "", " ");
        }
        if (property !== '7gen') {
            var matches = svgRef.current.querySelectorAll("[id^='property-']");
            for (let i = 0; i < matches.length; i++) {
                //console.log(matches[i].id);
                __updateElement(matches[i].id, "", "");
            }
        }

        for (let i = 0; i < hunder.length; i++) {
            const stamtavleHund = hunder[i];
            const id = stamtavleHund.sti;

            //__updateElement('name-' + id, text);
            __appendHundNavnLink('name-' + id, clipText(stamtavleHund.navn), process.env.PUBLIC_URL + "/hund?id=" + stamtavleHund.hundId);
            //const properties = pedigreeElement.properties;
            if (property !== '7gen') {
                let value =  "";
                if (property !== 'roentgen') {
                    value = stamtavleHund[property];
                } else {
                    if (stamtavleHund.hd !== null) {
                        value = "HD: " + stamtavleHund.hd;
                    }
                    if (stamtavleHund.ad !== null) {
                        value += value.length > 0
                            ? ", "
                            : '';
                        value += "AD: " + stamtavleHund.ad;
                    }

                    if (stamtavleHund.ocd !== null) {
                        value += value.length > 0
                            ? ", "
                            : '';
                        value += "OCD: " + (stamtavleHund.ocd === '1' ? 'Fri' : 'Påvist');
                    }
                    if (stamtavleHund.ryg !== null) {
                        value += value.length > 0
                            ? ", "
                            : '';
                        value += "Ryg: " + stamtavleHund.ryg;
                    }
                    if (stamtavleHund.udlRyg !== null) {
                        value += value.length > 0
                            ? ", "
                            : '';
                        value += "Udl.ryg: " + stamtavleHund.udlRyg;
                    }
                    if (stamtavleHund.patella !== null) {
                        value += value.length > 0
                            ? ", "
                            : '';
                        value += stamtavleHund.patella;
                    }
                }

                //const attributes = stamtavleHund[lookupProperty].attributes;
                //console.log("Test attributes" + attributes);
                __updateElement('property-' + id, value, null);
            }
        }
    });

    return (
        <>
            {
                property !== "7gen" && far &&
                    <DefaultFarSVG ref={svgRef} className="svg-pedigree" />
            }
            {
                property !== "7gen" && !far &&
                    <DefaultMorSVG ref={svgRef} className="svg-pedigree" />
            }

            {
                property === "7gen" && far &&
                <Gen7TreetFarSvg ref={svgRef} className="svg-pedigree-7gen" />
            }
            {
                property === "7gen" && !far &&
                <Gen7TreetMorSvg ref={svgRef} className="svg-pedigree-7gen" />
            }
        </>


    );
}


const StamtavleTre = (props) => {

    let history = useHistory();
    const parsed = qs.parse(decodeURI(props.location.search));
    let stamtavleLabel = 'tittel';
    if (parsed.stamLabel !== undefined) {
        stamtavleLabel = parsed.stamLabel;
    }

    const stamtavleTre = props.stamtavleTre;
    const hund = props.hund;
    const sisteHunder = props.sisteHunder;
    const favoritter = props.favoritter;

    const setStamtavleTreLabel = (t) => {
        let params = parsed
        if (t !== stamtavleLabel) {
            params.stamLabel = t;
        }
        delete params.query;
        delete params.antall;

        const currentPath = props.location.pathname;
        history.push(currentPath + "?" + qs.stringify(params));
    };


    /*
    const getProperDataChunk = () => (

        stamtavleLabel !== '8gen'
            ? stamtavleTre.data
            : stamtavleTre.data8Gen

    )
    */


    const getClassNames = (t) => {
        return (stamtavleLabel === t)
            ? "tabs-title tab-active"
            : "tabs-title";
    };


    const openUtvidetStamtavle = () => {
        setStamtavleTreLabel('utvidet-stamtavle');
        const url = process.env.REACT_APP_HUNDEWEB_ENDPOINT + "/hdb/openPage/stamtavle/stamtavle_hdb.html?HUID=" + hund.hundId;
        window.open(url, '_blank');
    };


    const renderBody = () => {

        if (stamtavleLabel === '7gen' && !stamtavleTre.loading8Gen) {
            return (
                <section id="pedigree-svg">
                    <StamtavleSVG
                        property={stamtavleLabel}
                        stamtavleData={stamtavleTre.data8Gen}
                        hundNavn={hund.navn}
                        far={true}
                    />
                    <StamtavleSVG
                        property={stamtavleLabel}
                        stamtavleData={stamtavleTre.data8Gen}
                        hundNavn={hund.navn}
                        far={false}
                    />
                </section>
            );
        }

        if (stamtavleLabel === '7gen' && stamtavleTre.loading8Gen) {
            return (<div>Loading 7 generasjoner</div>);
        }

        if (stamtavleLabel === 'fiktiv') {
            return (<Fiktiv hundId={hund.hundId} kjoenn={hund.kjoenn} sisteHunder={sisteHunder} favoritter={favoritter} />);
        }

        if (stamtavleLabel !== '7gen' && stamtavleLabel !== 'fiktiv' && stamtavleLabel !== 'udvidet-stamtavle'
            && (stamtavleLabel === 'tittel' || stamtavleLabel === 'farge'
                || stamtavleLabel === 'hundId' || stamtavleLabel === 'roentgen')) {
            return  (
                <section id="pedigree-svg">
                    <StamtavleSVG
                        property={stamtavleLabel}
                        stamtavleData={stamtavleTre.data}
                        far={true}
                    />
                    <StamtavleSVG
                        property={stamtavleLabel}
                        stamtavleData={stamtavleTre.data}
                        far={false}
                    />
                </section>
            );
        }
        return null;

    };


    return stamtavleTre.data
        ? (
            <div>
                <div className="tab-container">
                    <ul className="tree-options">
                        <li className={getClassNames('tittel')} style={{marginRight: "1rem", cursor: "pointer"}}
                            onClick={() => setStamtavleTreLabel('tittel')}>
                            <TabLabel name="Titel"/>
                        </li>
                        <li className={getClassNames('hundId')} style={{marginRight: "1rem", cursor: "pointer"}}
                            onClick={() => setStamtavleTreLabel('hundId')}>
                            <TabLabel name="Reg. Nr"/>
                        </li>
                        <li className={getClassNames('farge')} style={{marginRight: "1rem", cursor: "pointer"}}
                            onClick={() => setStamtavleTreLabel('farge')}>
                            <TabLabel name="Farve"/>
                        </li>
                        <li className={getClassNames('roentgen')} style={{marginRight: "1rem", cursor: "pointer"}}
                            onClick={() => setStamtavleTreLabel('roentgen')}>
                            <TabLabel name="Røntgen/led"/>
                        </li>

                        <li className={getClassNames('7gen')} style={{marginRight: "1rem", cursor: "pointer"}}
                            onClick={() => setStamtavleTreLabel('7gen')}>
                            <TabLabel name="7 Gen"/>
                        </li>
                        <li className={getClassNames('udvidet-stamtavle')} style={{marginRight: "1rem", cursor: "pointer"}}
                            onClick={openUtvidetStamtavle}>
                            <TabLabel name="Udvidet stamtavle"/>
                        </li>
                        <li className={getClassNames('fiktiv')} style={{marginRight: "1rem", cursor: "pointer"}}
                            onClick={() => {setStamtavleTreLabel('fiktiv')}}>
                            <TabLabel name="Fiktiv"/>
                        </li>
                    </ul>
                </div>

                {renderBody()}


            </div>
        )
        : stamtavleTre.loading ? (<div>Loading</div>) : null

};



export default withRouter (StamtavleTre);
